import { defineMessages } from 'react-intl'

export default defineMessages({
    confirmMarkAsPaidPrompt: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.confirmMarkAsPaidPrompt',
        defaultMessage: 'Are you sure you want to mark these tasks as paid? Please confirm from the downloaded CSV file.',
    }
})
